/**
 * Budget Table Add Button Row Component
 *
 * Separate table row component for displaying add buttons (+ Add Tópico / + Add Linha)
 * Appears after phase topics or topic line items in expanded view
 *
 * Design specs from Figma (node 3548-7958):
 * - Height: 70px
 * - Alignment: justify-end (button aligned to right)
 * - Button specs:
 *   - Border: #7846FF
 *   - Width: 135-160px (flexible based on text)
 *   - Height: 50px
 *   - Border-radius: 10px
 *   - Text color: #F5F2FF
 *   - Font: 16px bold
 *   - Background: transparent with hover effect
 */

import { PhaseColor } from "@/types/orcamentos.interface";

interface BudgetTableAddButtonRowProps {
  /** Optional array of buttons to display */
  buttons?: { text: string; onClick: () => void }[];
  /** Legacy: Button text (e.g., "+ Add Tópico") */
  buttonText?: string;
  /** Legacy: Click handler */
  onClick?: () => void;
  /** Phase color for styling consistency */
  phaseColor: PhaseColor;
}

/**
 * Get background color with low opacity based on phase color identifier
 */
function getRowBackground(color: PhaseColor): string {
  const colorMap: Record<PhaseColor, string> = {
    purple: "rgba(120, 70, 255, 0.05)",
    teal: "rgba(19, 212, 128, 0.05)",
    orange: "rgba(255, 107, 74, 0.05)",
  };
  return colorMap[color];
}

export function BudgetTableAddButtonRow({
  buttons,
  buttonText,
  onClick,
  phaseColor,
}: BudgetTableAddButtonRowProps) {
  return (
    <tr
      className="h-[70px]"
      style={{ backgroundColor: getRowBackground(phaseColor) }}
    >
      {/* Spans all columns, content aligned to right */}
      <td colSpan={7} className="px-[20px]">
        <div className="flex items-center justify-end gap-[10px]">
          {buttons ? (
            buttons.map((btn, index) => (
              <button
                key={index}
                onClick={btn.onClick}
                className="h-[40px] px-[20px] rounded-[10px] border border-[#7846FF] text-[#F5F2FF] text-[14px] font-normal bg-transparent hover:bg-[rgba(120,70,255,0.1)] transition-colors whitespace-nowrap overflow-hidden text-ellipsis"
                style={{ width: '150px' }}
              >
                {btn.text}
              </button>
            ))
          ) : (
            <button
              onClick={onClick}
              className="h-[40px] min-w-[140px] max-w-[160px] px-[20px] rounded-[10px] border border-[#7846FF] text-[#F5F2FF] text-[14px] font-normal bg-transparent hover:bg-[rgba(120,70,255,0.1)] transition-colors whitespace-nowrap overflow-hidden text-ellipsis"
            >
              {buttonText}
            </button>
          )}
        </div>
      </td>
    </tr>
  );
}
